import { Flex, Spin } from "antd"

import CreditCard from "../CreditCard/CreditCard"

import "./CreditsList.less"

const CreditsList = ({ data, handleSelectRow, handleChangeStatus, loading, emptyComponent }) => {
  return (
    <Spin spinning={loading}>
      {data.length === 0 && (
        <Flex align="center" justify="center">
          {emptyComponent}
        </Flex>
      )}
      <div className="credits-cards-list">
        {data.map((item) => (
          <CreditCard
            key={item.id}
            cr={item}
            handleSelectRow={handleSelectRow}
            handleChangeStatus={handleChangeStatus}
          />
        ))}
      </div>
    </Spin>
  )
}

export default CreditsList
